import { Injectable, inject } from '@angular/core';
import { AnalyticsService } from '@athena/util-monitoring';

export const NAV_PROFILE_SOURCES = ['desktop-nav', 'mobile-nav', 'direct'] as const;
export type NavProfileSource = (typeof NAV_PROFILE_SOURCES)[number];

@Injectable({ providedIn: 'root' })
export class ProfileAnalyticsService {
  readonly #analytics = inject(AnalyticsService);

  profileViewed(hasSavedPreferences: boolean): void {
    this.#analytics.trackEvent('profile::viewed', { hasSavedPreferences });
  }

  detailsEditStarted(): void {
    this.#analytics.trackEvent('profile::details::editStarted');
  }

  detailsSaved(fieldsChanged: number): void {
    this.#analytics.trackEvent('profile::details::saved', { fieldsChanged });
  }

  detailsSaveFailed(): void {
    this.#analytics.trackEvent('profile::details::saveFailed');
  }

  detailsEditCancelled(): void {
    this.#analytics.trackEvent('profile::details::editCancelled');
  }

  preferencesUpdateClicked(): void {
    this.#analytics.trackEvent('profile::preferences::updateClicked');
  }

  navProfileOpened(source: NavProfileSource): void {
    this.#analytics.trackEvent('nav::profile::opened', { source });
  }

  passwordChangeRequested(): void {
    this.#analytics.trackEvent('profile::password::changeRequested');
  }

  passwordResetEmailSent(): void {
    this.#analytics.trackEvent('profile::password::resetEmailSent');
  }

  lookingForGetMatchedClicked(): void {
    this.#analytics.trackEvent('profile::lookingFor::getMatchedClicked');
  }
}
